import img1 from '../assets/images/GAS/G3.jpg';
import img2 from '../assets/images/GAS/G1.jpg';
import img3 from '../assets/images/GAS/G8.jpg';
import img4 from '../assets/images/GAS/G6.jpg';
import img5 from '../assets/images/GAS/G1.jpg';
import img6 from '../assets/images/GAS/G3.jpg';
import img7 from '../assets/images/GAS/G7.jpg';
import img8 from '../assets/images/GAS/G9.jpg';
import Contact from './content';

function Gallery() {
    return (
        <>
            <section className="gallery-section overlay text-white pt-115 rpt-95 pb-100 rpb-80" id="gallery">
                <div className="container-fluid ">
                    <div className="section-title text-center mb-55">
                        <span className="sub-title">Our Gallery</span>
                        <h2>Our Gallery</h2>
                    </div>
                    <div className="row small-gap">
                        <div className="col-lg-3 col-sm-6">
                            <div className="gallery-item wow fadeInUp delay-0-2s">
                                <img src={img1} alt="Gallery" />
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <div className="gallery-item wow fadeInUp delay-0-4s">
                                <img src={img2} alt="Gallery" />
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <div className="gallery-item wow fadeInUp delay-0-6s">
                                <img src={img3} alt="Gallery" />
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <div className="gallery-item wow fadeInUp delay-0-8s">
                                <img src={img4} alt="Gallery" />
                            </div>
                        </div>
                    </div>
                    <div className="row small-gap">
                        <div className="col-lg-3 col-sm-6">
                            <div className="gallery-item wow fadeInUp delay-0-2s">
                                <img src={img5} alt="Gallery" />
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <div className="gallery-item wow fadeInUp delay-0-4s">
                                <img src={img6} alt="Gallery" />
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <div className="gallery-item wow fadeInUp delay-0-6s">
                                <img src={img7} alt="Gallery" />
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <div className="gallery-item wow fadeInUp delay-0-8s">
                                <img src={img8} alt="Gallery" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Contact />
        </>
    );
}

export default Gallery;